import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import swal from 'sweetalert'
import { Button, Icon } from 'antd'

import './BaseDialogs.scss'

export default {
    open(component) {
        const content = document.createElement('div')
        ReactDOM.render(component, content)
        return swal({
            className: 'sf-base-dialog',
            content,
            buttons: false,
            closeOnClickOutside: false
        })
    }
}

export class BaseDialog extends Component {

    close() {
        swal.close()
    }

    render() {
        const { key, icon, title, children, footer } = this.props

        return (
            <div key={key || 'sf-base-dialog'}>
                <div className="dialog-header">
                    <div className="dialog-title" id="rcDialogTitle0">
                        {icon && <i className={icon} />} {title}
                    </div>
                    <button aria-label="Close" className="dialog-close" onClick={this.close}>
                        <Icon type='close' />
                    </button>
                </div>
                <div className='dialog-body'>
                    {children}
                </div>
                {typeof footer !== 'undefined' ? footer :
                    <div className="dialog-footer">
                        <div>
                            <Button className='sf-dialog-btn' onClick={this.close}>Fechar</Button>
                            {/* <Button className="sf-dialog-btn grey-salt" type="primary">Ok</Button> */}
                        </div>
                    </div>
                }
            </div >
        )
    }

}
